import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import QTip from 'components/QuickenControls/QTip';
import ButtonBase from '@material-ui/core/ButtonBase';

const styles = () => {

  const dayWidth = 14.28;

  const ret = {};

  ret.day = {
    position: 'relative',
    flex: `1 0 ${dayWidth}%`,
    maxWidth: 'calc(100% / 7)',
    minHeight: 100,
    padding: 5,
    boxShadow: '1px -1px 0px #777',
    borderLeft: 'solid 1px #777',
    borderBottom: 'solid 1px #777',
  };
  for (let i = 1; i < 9; i++) {
    ret[`first-index-${i}`] = {
      marginLeft: `${dayWidth * i + 0.02}%`,
    };
  }
  ret.header = {
    fontSize: '15px',
    fontWeight: 700,
    marginBottom: 5,
  };
  ret.label1 = {
    float: 'left',
    padding: 0,
    margin: 0,
    fontSize: '12px',
    color: '#555',
    textAlign: 'left',
    cursor: 'pointer',
    '&:hover': {
      background: '#efefef',
    },
  };

  ret.label2 = {
    float: 'right',
    padding: 0,
    margin: 0,
    fontSize: '12px',
    color: '#555',
    textAlign: 'left',
    cursor: 'pointer',
    '&:hover': {
      background: '#efefef',
    },
  };

  return ret;
}


class CalDay extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  itemClick = (id) => {
    if (this.props.onItemClick) {
      this.props.onItemClick(id);
    }
  };
  render() {

    const { classes, day, labels, firstDayIndex } = this.props;

    const cssClasses = firstDayIndex
      ? classNames(classes.day, classes[`first-index-${firstDayIndex}`])
      : classes.day;

    const txs = labels ? labels.map((x) => (
      <QTip key={`lbl:${x.key}:${day}`} title={x.tooltip} position="bottom">
        <div>
          <ButtonBase
            onClick={() => this.itemClick(x.key)}
            style={{ width: '100% ' }}
          >
            <div style={{ width: 'inherit', display: 'inline-block' }}>
              <div className={classes.label1} style={x.style}> {x.label1} </div>
              <div className={classes.label2} style={x.style}> {x.label2} </div>
            </div>
          </ButtonBase>
        </div>
      </QTip>)) : '';

    return (
      <article className={cssClasses}>
        <>
          <header className={classes.header}>{day}</header>
          <div>
            {txs}
          </div>
        </>
      </article>
    );
  }
}

const mapStateToProps = () => ({});


const mapDispatchToProps = () => ({});

CalDay.propTypes = {
  classes: PropTypes.object,
  firstDayIndex: PropTypes.string,
  labels: PropTypes.array,
  day: PropTypes.number,
  onItemClick: PropTypes.func,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(CalDay);
